import React from "react";
import {useHistory} from "react-router";
import URLSearchParamsConverter from "../../utils/URLSearchParamsConverter";

const items = [
    {
        label: "Przestronne SUVy",
        img: "/img/wyszukiwania/suvy.jpg",
        params: {bodyTypes: ["SUV / Crossover"], vehicleTypes: ["OSOBOWE"]}
    },
    {
        label: "Tylko 4x4",
        img: "/img/wyszukiwania/4x4.png",
        params: {driveTypes: ["Napęd na 4 koła"]}
    },
    {
        label: "Marki premium",
        img: "/img/wyszukiwania/premium.jpg",
        params: {isPremium: true, vehicleTypes: ["OSOBOWE"]}
    },
    {
        label: "Sportowy duch",
        img: "/img/wyszukiwania/sportowy duch.jpg",
        params: {segments: ["Sportowe"], vehicleTypes: ["OSOBOWE"]}
    },
    {
        label: "Marki chińskie",
        img: "/img/wyszukiwania/marki chinskie.jpg",
        params: {
            brands: ["BYD", "CHERY", "GEELY", "FORTHING", "JAECOO", "OMODA", "XPENG"],
            vehicleTypes: ["OSOBOWE"]
        }
    },
    {
        label: "Najwyższe rabaty",
        img: "/img/wyszukiwania/najwyzsze rabaty.png",
        params: {vehicleTypes: ["OSOBOWE"], sortingType: "DISCOUNT_DESC"}
    },
    {
        label: "Elektryki",
        img: "/img/wyszukiwania/elektryki.jpg",
        params: {fuelTypes: ["Elektryczny"], vehicleTypes: ["OSOBOWE"]}
    },
    {
        label: "Małe miejskie",
        img: "/img/wyszukiwania/miejskie.jpg",
        params: {segments: ["Miejskie / małe"], vehicleTypes: ["OSOBOWE"]}
    },
];

function PopularSearches() {
    const history = useHistory();

    const handleSearch = (params) => {
        history.push({
            pathname: "/lista-ofert",
            search: URLSearchParamsConverter.createURLSearchString(params)
        });
    };

    return (
        <section className="popular-searches">
            <div className="container">
                <h2 className="popular-searches-heading">Najpopularniejsze wyszukiwania</h2>
                <div className="popular-searches-grid">
                    {items.map((item, i) => (
                        <div key={i} className="popular-searches-card" onClick={() => handleSearch(item.params)}>
                            <div className="popular-searches-img">
                                <img src={item.img} alt={item.label}/>
                            </div>
                            <span className="popular-searches-label">{item.label}</span>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default PopularSearches;
